<script>
  import { construct_svelte_component } from "svelte/internal";
  import ImcIndicator from "./IMCIndicator.svelte";
    import PercentuaisMacro from "./percentuaisMacro.svelte";
  
  // Variáveis de entrada
  let nivelAtividade = "";
  let idade = 0;
  let genero = "";
  let peso = 0;
  let altura = 0;
  let gravida = false;
  let trimestre = "";
  let imc = 0;
  let af = 0;
  let af2 = 0;
  let neeAtual = 0;
  let neeMifflin = 0;
  let metodoAtual = "";
  let criterioAtual = "";
  let formulaAtual = "";
  let metodoMifflin = "Mifflin-St Jeor";
  let criterioMifflin = "Fórmula de Mifflin-St Jeor";
  let formulaMifflin = "";
  let imcClassificacao = "";
  let pesoSelecionado = 0;
  let pesosTeoricos={};
  let neeHarrisBenedict =0
 let formulaHarrisBenedict = '';
  // Função para calcular o IMC
  function calcularIMC() {
    imc = peso / (altura * altura);
    classificarIMC();
  }
  function calcularPesosTeoricos() {
    const alturaQuadrado = altura * altura;
    if (genero === "masculino") {
      pesosTeoricos = {
        minimo: alturaQuadrado * 20.1,
        medio: alturaQuadrado * 22.0,
        maximo: alturaQuadrado * 25.0
      };
    } else if (genero === "feminino") {
      pesosTeoricos = {     
        minimo: alturaQuadrado * 18.7,
        medio: alturaQuadrado * 20.8,
        maximo: alturaQuadrado * 23.8
      };
      
    }
   
  }

  // Atualizar pesos teóricos sempre que peso ou altura mudarem
 
  // Função para classificar o IMC
  function classificarIMC() {
    if (imc < 18.5) {
      imcClassificacao = "Abaixo do peso";
    } else if (imc >= 18.5 && imc < 24.9) {
      imcClassificacao = "Peso normal";
    } else if (imc >= 25 && imc < 29.9) {
      imcClassificacao = "Sobrepeso";
    } else {
      imcClassificacao = "Obesidade";
    }
  }

  // Função para calcular o AF com base nos inputs no contexto atual
  function calcularAFAtual() {
    if (genero === "masculino") {
      if (idade >= 9 && idade <= 18) {
        if (imc > 25) {
          // Meninos de 9-18 anos com sobrepeso
          if (nivelAtividade === "sedentario") af = 1.0;
          else if (nivelAtividade === "pouco ativo") af = 1.12;
          else if (nivelAtividade === "ativo") af = 1.24;
          else if (nivelAtividade === "muito ativo") af = 1.45;
        } else {
          // Meninos de 9-18 anos com IMC normal
          if (nivelAtividade === "sedentario") af = 1.0;
          else if (nivelAtividade === "pouco ativo") af = 1.13;
          else if (nivelAtividade === "ativo") af = 1.26;
          else if (nivelAtividade === "muito ativo") af = 1.42;
        }
      } else if (idade >= 19) {
        if (imc > 25) {
          // Homens a partir de 19 anos com sobrepeso
          if (nivelAtividade === "sedentario") af = 1.0;
          else if (nivelAtividade === "pouco ativo") af = 1.12;
          else if (nivelAtividade === "ativo") af = 1.29;
          else if (nivelAtividade === "muito ativo") af = 1.59;
        } else {
          // Homens a partir de 19 anos com IMC normal
          if (nivelAtividade === "sedentario") af = 1.0;
          else if (nivelAtividade === "pouco ativo") af = 1.11;
          else if (nivelAtividade === "ativo") af = 1.25;
          else if (nivelAtividade === "muito ativo") af = 1.48;
        }
      }
    } else if (genero === "feminino") {
      if (idade >= 9 && idade <= 18) {
        if (imc > 25) {
          // Meninas de 9-18 anos com sobrepeso
          if (nivelAtividade === "sedentario") af = 1.0;
          else if (nivelAtividade === "pouco ativo") af = 1.18;
          else if (nivelAtividade === "ativo") af = 1.35;
          else if (nivelAtividade === "muito ativo") af = 1.6;
        } else {
          // Meninas de 9-18 anos com IMC normal
          if (nivelAtividade === "sedentario") af = 1.0;
          else if (nivelAtividade === "pouco ativo") af = 1.16;
          else if (nivelAtividade === "ativo") af = 1.31;
          else if (nivelAtividade === "muito ativo") af = 1.56;
        }
      } else if (idade >= 19) {
        if (imc > 25) {
          // Mulheres a partir de 19 anos com sobrepeso
          if (nivelAtividade === "sedentario") af = 1.0;
          else if (nivelAtividade === "pouco ativo") af = 1.16;
          else if (nivelAtividade === "ativo") af = 1.27;
          else if (nivelAtividade === "muito ativo") af = 1.44;
        } else {
          // Mulheres a partir de 19 anos com IMC normal
          if (nivelAtividade === "sedentario") af = 1.0;
          else if (nivelAtividade === "pouco ativo") af = 1.12;
          else if (nivelAtividade === "ativo") af = 1.27;
          else if (nivelAtividade === "muito ativo") af = 1.45;
          console.log("entrei aqui ");
        }
      }
    }

    console.log(nivelAtividade);
    console.log(af);
    console.log(genero);
    console.log(idade);
    console.log(imc);
  }

  // Função para calcular o AF com base nos inputs no contexto de Mifflin-St Jeor
  function calcularAFMifflin() {
    if (nivelAtividade === "sedentario") af2 = 1.2;
    else if (nivelAtividade === "pouco ativo") af2 = 1.4;
    else if (nivelAtividade === "ativo") af2 = 1.6;
    else if (nivelAtividade === "muito ativo") af2 = 1.9;
  }
 
  function calcularNEEHarrisBenedict() {
    const pesoParaCalculo = pesoSelecionado;
    let bmr;

    if (genero === "masculino") {
      bmr = 66.47 + (13.75 * pesoParaCalculo) + (5.003 * altura * 100) - (6.775 * idade);
      formulaHarrisBenedict = 'NEE =  66.47 + (13.75 * pesoParaCalculo) + (5.003 * altura * 100) - (6.775 * idade) X AF';
    } else {
      bmr = 655.1  + (9.563 * pesoParaCalculo) + (1.850 * altura * 100) - (4.676 * idade);
      formulaHarrisBenedict = `NEE = (655.1  + (9.563 * pesoParaCalculo) + (1.850 * altura * 100) - (4.676 * idade)) X AF`;
    }

    neeHarrisBenedict = bmr * af2;
    
  }
  // Função para calcular o NEE com base nos inputs()
  function calcularNEE() {
    calcularIMC();
    metodoAtual = "";
    criterioAtual = "";
    formulaAtual = "";
    neeAtual = 0;
    neeMifflin = 0;
    const pesoParaCalculo = pesoSelecionado;
    // Calcular com as fórmulas atuais
    if (genero === "masculino") {
      if (idade >= 3 && idade <= 8) {
        calcularAFAtual();
        neeAtual = 88.5 - 61.9 * idade + af * (26.7 * pesoParaCalculo + 903 * altura) + 20;
        criterioAtual =
          "NEE PARA MENINOS DE 3 – 8 ANOS DE IDADE (DENTRO DO PERCENTIL 5 – 85 PARA IMC)";
        formulaAtual =
          "NEE = 88,5 – 61,9 x idade (anos) + AF x (26,7 x peso [Kg] + 903 x altura [m]) + 20 (Kcal para a deposição de energia)";
        metodoAtual = "Atual";
      } else if (idade >= 9 && idade <= 18) {
        calcularAFAtual();
        neeAtual = 88.5 - 61.9 * idade + af * (26.7 * pesoParaCalculo + 903 * altura) + 25;
        criterioAtual =
          "NEE PARA MENINOS DE 9 – 18 ANOS DE IDADE (DENTRO DO PERCENTIL 5 – 85 PARA IMC)";
        formulaAtual =
          "NEE = 88,5 – 61,9 x idade (anos) + AF x (26,7 x peso [Kg] + 903 x altura [m]) + 25 (Kcal para a deposição de energia)";
        metodoAtual = "Atual";
      } else if (idade >= 19) {
        calcularAFAtual();
        if (imc > 25) {
          neeAtual = 1086 - 10.1 * idade + af * (13.7 * pesoParaCalculo + 416 * altura);
          criterioAtual =
            "HOMENS COM SOBREPESO E OBESO A PARTIR DE 19 ANOS (IMC >25Kg/m2)";
          formulaAtual =
            "NEE = 1086 – 10,1 x idade (anos) + AF x (13,7 x peso [Kg] + 416 x altura [m])";
        } else {
          neeAtual = 662 - 9.53 * idade + af * (15.91 * pesoParaCalculo + 539.6 * altura);
          criterioAtual =
            "NEE PARA HOMENS A PARTIR DE 19 ANOS (IMC 18,5 – 25 Kg/m2)";
          formulaAtual =
            "NEE = 662 – 9,53 x idade (anos) + AF x (15.91 x peso [Kg] + 539.6 x altura [m])";
        }
        metodoAtual = "Atual";
      }
    } else if (genero === "feminino") {
      if (idade >= 3 && idade <= 8) {
        calcularAFAtual();
        neeAtual = 135.3 - 30.8 * idade + af * (10 * pesoParaCalculo + 934 * altura) + 20;
        criterioAtual =
          "NEE PARA MENINAS DE 3 – 8 ANOS DE IDADE (DENTRO DO PERCENTIL 5 – 85 PARA IMC)";
        formulaAtual =
          "NEE = 135,3 – 30,8 x idade (anos) + AF x (10 x peso [Kg] + 934 x altura [m]) + 20 (Kcal para a deposição de energia)";
        metodoAtual = "Atual";
      } else if (idade >= 9 && idade <= 18) {
        calcularAFAtual();
        neeAtual = 135.3 - 30.8 * idade + af * (10 * pesoParaCalculo + 934 * altura) + 25;
        criterioAtual =
          "NEE PARA MENINAS DE 9 – 18 ANOS DE IDADE (DENTRO DO PERCENTIL 5 – 85 PARA IMC)";
        formulaAtual =
          "NEE = 135,3 – 30,8 x idade (anos) + AF x (10 x peso [Kg] + 934 x altura [m]) + 25 (Kcal para a deposição de energia)";
        metodoAtual = "Atual";
      } else if (idade >= 19) {
        calcularAFAtual();
        if (imc > 25) {
          neeAtual = 448 - 7.95 * idade + af * (11.4 * pesoParaCalculo + 619 * altura);
          criterioAtual =
            "MULHERES COM SOBREPESO E OBESA A PARTIR DOS 19 ANOS (IMC >25 Kg/m2)";
          formulaAtual =
            "NEE = 448 – 7,95 x idade (anos) + AF x (11,4 x peso [Kg] + 619 x altura [m])";
        } else {
          neeAtual = 354 - 6.91 * idade + af * (9.36 * pesoParaCalculo + 726 * altura);
          criterioAtual =
            "NEE PARA MULHERES A PARTIR DE 19 ANOS (IMC 18,5 – 25 Kg/m2)";
          formulaAtual =
            "NEE = 354 – 6,91 x idade (anos) + AF x (9.36 x peso [Kg] + 726 x altura [m])";
        }
        metodoAtual = "Atual";
      }

      // Ajustar NEE para grávidas
      if (gravida && trimestre !== "") {
        let ajuste = 0;
        if (trimestre === "primeiro") {
          ajuste = 0; // Primeiro trimestre: NEE de adulta + 0 Kcal
        } else if (trimestre === "segundo") {
          ajuste = 160 + 180; // Segundo trimestre: NEE de adulta + 160 Kcal + 180 Kcal
        } else if (trimestre === "terceiro") {
          ajuste = 272 + 180; // Terceiro trimestre: NEE de adulta + 272 Kcal + 180 Kcal
        }
        neeAtual += ajuste;
        criterioAtual += " (Grávida, " + trimestre + " trimestre)";
        formulaAtual += " + " + ajuste + " kcal";
      }
    }

    // Calcular com a fórmula de Mifflin-St Jeor
    calcularAFMifflin();
    if (genero === "masculino") {
      neeMifflin = (10 * pesoParaCalculo + 6.25 * altura * 100 - 5 * idade + 5) * af2;
      formulaMifflin =
        "NEE = (10 x peso [Kg] + 6.25 x altura [cm] - 5 x idade [anos] + 5) x AF";
    } else {
      neeMifflin = (10 * pesoParaCalculo + 6.25 * altura * 100 - 5 * idade - 161) * af2;
      formulaMifflin =
        "NEE = (10 x peso [Kg] + 6.25 x altura [cm] - 5 x idade [anos] - 161) x AF";

      // Ajustar NEE para grávidas na fórmula de Mifflin-St Jeor
      if (gravida && trimestre !== "") {
        let ajuste = 0;
        if (trimestre === "primeiro") {
          ajuste = 0; // Primeiro trimestre: NEE de adulta + 0 Kcal
        } else if (trimestre === "segundo") {
          ajuste = 160 + 180; // Segundo trimestre: NEE de adulta + 160 Kcal + 180 Kcal
        } else if (trimestre === "terceiro") {
          ajuste = 272 + 180; // Terceiro trimestre: NEE de adulta + 272 Kcal + 180 Kcal
        }
        neeMifflin += ajuste;
        criterioMifflin += " (Grávida, " + trimestre + " trimestre)";
        formulaMifflin += " + " + ajuste + " kcal";
      }
    }
    calcularNEEHarrisBenedict()
  }
</script>
<!-- Certifique-se de incluir o CSS do Bootstrap no seu projeto -->
<!-- Certifique-se de incluir o CSS do Bootstrap no seu projeto -->

<div class="container">
  <h1>Calculadora de Necessidade Energética Estimada (NEE)</h1>

  <label for="nivelAtividade">Nível de Atividade Física</label>
  <select id="nivelAtividade" class="form-control" bind:value={nivelAtividade}>
    <option value="" disabled selected>Selecione...</option>
    <option value="sedentario">Sedentário(a) (menos de 30 minutos/semana)</option>
    <option value="pouco ativo">Pouco ativo(a) (30-150 minutos/semana)</option>
    <option value="ativo">Ativo(a) (150-300 minutos/semana)</option>
    <option value="muito ativo">Muito ativo(a) (mais de 300 minutos/semana)</option>
  </select>

  <label for="idade">Idade</label>
  <input type="number" id="idade" class="form-control" bind:value={idade} min="0" />

  <label for="genero">Gênero</label>
  <select id="genero" class="form-control" bind:value={genero} on:change={calcularPesosTeoricos}>
    <option value="" disabled selected>Selecione...</option>
    <option value="masculino">Masculino</option>
    <option value="feminino">Feminino</option>
  </select>

  {#if genero === "feminino"}
    <label for="gravida">Está grávida?</label>
    <input type="checkbox" id="gravida" class="form-check-input" bind:checked={gravida} />

    {#if gravida}
      <label for="trimestre">Trimestre da gravidez</label>
      <select id="trimestre" class="form-control" bind:value={trimestre}>
        <option value="" disabled selected>Selecione...</option>
        <option value="primeiro">Primeiro trimestre</option>
        <option value="segundo">Segundo trimestre</option>
        <option value="terceiro">Terceiro trimestre</option>
      </select>
    {/if}
  {/if}

  <label for="altura">Altura (m)</label>
  <input type="number" id="altura" class="form-control" bind:value={altura} min="0" step="0.01" on:input={calcularPesosTeoricos} />
  
  <label for="peso">Peso (kg)</label>
  <input type="number" id="peso" class="form-control" bind:value={peso} min="0" step="0.1" on:input={calcularPesosTeoricos}/>

  {#if peso > 0 && altura > 0 && pesosTeoricos && genero}
    <label for="pesoSelecionado">Selecione o peso a ser utilizado no cálculo:</label>
    <select id="pesoSelecionado" class="form-control" bind:value={pesoSelecionado}>
      <option value={peso}>Peso Real: {peso} kg</option>
      {#if pesosTeoricos.minimo}
      <option value={pesosTeoricos.minimo}>Peso Teórico Mínimo: {pesosTeoricos.minimo.toFixed(2)} kg</option>
      {/if}
      {#if pesosTeoricos.medio}
      <option value={pesosTeoricos.medio}>Peso Teórico Médio: {pesosTeoricos.medio.toFixed(2)} kg</option>
      {/if}
      {#if pesosTeoricos.maximo}
      <option value={pesosTeoricos.maximo}>Peso Teórico Máximo: {pesosTeoricos.maximo.toFixed(2)} kg</option>
      {/if}
    </select>
  {/if}

  <button class="btn btn-primary mt-3" on:click={calcularNEE}>Calcular NEE</button>

  {#if imc > 0}
    <ImcIndicator {imc} />

    <div class="result-card card mt-3">
      <div class="card-body">
        {#if af > 0}
          <p>
            O coeficiente de atividade física (AF) correspondente (Método Atual)
            é: {af}
          </p>
        {/if}

        {#if neeAtual > 0}
          <h5 class="card-title">Método Atual</h5>
          <p>
            A Necessidade Energética Estimada (NEE) pelo método atual é: <strong
            >
              {neeAtual.toFixed(2)} kcal/dia
            </strong>
          </p>
          <p>(Calculado usando o método: {metodoAtual})</p>
          <p>Critério: {criterioAtual}</p>
          <p>Fórmula utilizada: {formulaAtual}</p>
        {/if}
      </div>
    </div>

    <div class="result-card card mt-3">
      <div class="card-body">
        {#if af2 > 0}
          <p>
            O coeficiente de atividade física (AF) correspondente (Método
            Mifflin-St Jeor) é: {af2}
          </p>
        {/if}

        {#if neeMifflin > 0}
          <h5 class="card-title">Método Mifflin-St Jeor</h5>
          <p>
            A Necessidade Energética Estimada (NEE) pelo método Mifflin-St Jeor
            é:<strong>{neeMifflin.toFixed(2)} kcal/dia</strong>
          </p>
          <p>(Calculado usando o método: {metodoMifflin})</p>
          <p>Critério: {criterioMifflin}</p>
          <p>Fórmula utilizada: {formulaMifflin}</p>
        {/if}
      </div>
    </div>
    <div class="result-card card mt-3">
      <div class="card-body">
        {#if af2 > 0}
          <p>
            O coeficiente de atividade física (AF) correspondente (Método
            HARRIS-BENEDICT) é: {af2}
          </p>
        {/if}

        {#if neeMifflin > 0}
          <h5 class="card-title">Método HARRIS-BENEDICT</h5>
          <p>
            A Necessidade Energética Estimada (NEE) pelo método HARRIS-BENEDICT
            é:<strong>{neeHarrisBenedict.toFixed(2)} kcal/dia</strong>
          </p>
          <p>(Calculado usando o método: HARRIS-BENEDICT)</p>
          <p>Critério: Fórmula de HERRIS-BENEDICT</p>
          <p>Fórmula utilizada: {formulaHarrisBenedict}</p>
        {/if}
      </div>
    </div>
    <PercentuaisMacro nee={neeAtual} nee2={neeMifflin} nee3={neeHarrisBenedict} />
  {/if}
</div>

<style>
  .container {
    max-width: 600px;
    margin: 0 auto;
    padding: 1rem;
    border: 1px solid #ccc;
    border-radius: 0.5rem;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  label {
    display: block;
    margin-top: 1rem;
  }
  input,
  select {
    width: 100%;
    padding: 0.5rem;
    margin-top: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 0.25rem;
  }
  button {
    margin-top: 1rem;
    padding: 0.5rem 1rem;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 0.25rem;
    cursor: pointer;
  }
  button:hover {
    background-color: #0056b3;
  }
  .result-card {
    margin-top: 1rem;
  }
</style>